// eslint-disable-next-line import/no-unassigned-import
import 'application/optimizely';
import {
  PublicWebNav,
  PublicWebNavV2,
  mount,
} from '@squareup/public-web-nav/esm';
import { canUseDashboardMode } from 'utilities/dashboard_mode';
import { DISPLAY_MODES } from 'constants/enums';

window.Sq = window.Sq || {};

const initPublicWebNav = () => {
  const el = document.getElementById('public-web-nav');

  if (el === null) {
    return;
  }
  const renderNavV2 = el.dataset.renderNavV2 === 'true';
  const PublicWebNavComponent = renderNavV2 ? PublicWebNavV2 : PublicWebNav;

  Sq.PublicWebNav = mount(PublicWebNavComponent, {
    target: el,
    intro: true,
    props: {
      dataJSON: el.dataset.json,
      imageSubnavJSON: el.dataset.imageSubnavJson,
      ctaSubnavJSON: el.dataset.ctaSubnavJson,
      flagsJSON: el.dataset.flagsJson,
      loggedIn: el.dataset.loggedIn === 'true',
      zIndex: 3,
    },
  });

  const signInEl = el.querySelector("a[href='/login']");
  const redirectLink = document.getElementById(
    'link-to-redirect-after-login',
  ).value;
  if (signInEl && redirectLink) {
    signInEl.href = redirectLink;
  }

  if (el.dataset.experiments) {
    // Allow if OneTrust is not defined or if it is defined and tracking explicitly allowed
    if (
      Sq.Shop.Optimizely &&
      (!Sq.OneTrust || Sq.OneTrust.functionalityTrackingEnabled)
    ) {
      Sq.Shop.Optimizely.activate(el.dataset.experiments);
    }
  }
};

const searchParams = new URLSearchParams(window.location.search);
if (
  searchParams.get('mode')?.toLowerCase() !== DISPLAY_MODES.DASHBOARD ||
  !canUseDashboardMode(window.location.pathname)
) {
  document.addEventListener('DOMContentLoaded', initPublicWebNav);
}
